module.exports = __webpack_public_path__ + "img/female.42931ea2.svg";